import {
  HEADER_HEIGHT_MD_LG_XL,
  HEADER_HEIGHT_XS_SM,
} from '@/styles/theme/constants';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'HeroCarouselSlide',
})(({ breakpoints, typography: { pxToRem } }) => ({
  hFull: {
    height: '100%',
  },
  immersive: {
    [breakpoints.up('sm')]: { marginTop: pxToRem(HEADER_HEIGHT_XS_SM) },
    [breakpoints.up('md')]: { marginTop: pxToRem(HEADER_HEIGHT_MD_LG_XL) },
  },
  innerContentSpacing: {
    [breakpoints.up('sm')]: { paddingTop: pxToRem(37) },
    [breakpoints.up('md')]: { paddingTop: pxToRem(29) },
    [breakpoints.up('lg')]: { paddingTop: pxToRem(48) },
    [breakpoints.up('xl')]: { paddingTop: pxToRem(85) },

    // horizontally aligned only between xs-sm
    [breakpoints.down('sm')]: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    },
  },
}));

export default useStyles;
